import type { Result as HotOfferResult } from '../hot-offers/types';

export type SpecialType = 'EVENT' | 'AIRLINE_PROMO';

export interface CityOrCountryRef {
  iata_code: string;
  name: string;
}

export interface CountryIsoRef {
  iso_code: string;
  name: string;
}

export interface LocationRef {
  city: CityOrCountryRef;
  country: CityOrCountryRef;
}

export interface PriceRef {
  currency: string;
  amount: string;
}

export interface BaseSpecial {
  id: string; // uuid
  type: SpecialType;
  title: string;
  subtitle?: string | null;
  description?: string | null;
  image_url?: string | null;
  tags?: string[];
  price?: PriceRef;
  requested_dep_city: string; // requested dep_city
  provided_dep_city: string; // actual dep_city used for the price if requested not available
}

export interface EventSpecial extends BaseSpecial {
  type: 'EVENT';
  date?: string;
  location: LocationRef;
  event_tickets_url?: string;
}

export interface ToCitiesDirections {
  type: 'TO_CITIES';
  routes: CityOrCountryRef[];
}

export interface ToCountriesDirections {
  type: 'TO_COUNTRIES';
  routes: CountryIsoRef[];
}

export interface CitiesToCitiesDirectionsRoute {
  origin: CityOrCountryRef;
  destination: CityOrCountryRef;
}

export interface CitiesToCitiesDirections {
  type: 'CITIES_TO_CITIES';
  routes: CitiesToCitiesDirectionsRoute[];
}

export interface CountriesToCountriesDirectionsRoute {
  origin: CountryIsoRef;
  destination: CountryIsoRef;
}

export interface CountriesToCountriesDirections {
  type: 'COUNTRIES_TO_COUNTRIES';
  routes: CountriesToCountriesDirectionsRoute[];
}

export interface AllDirections {
  type: 'ALL';
}

export type Directions =
  | ToCitiesDirections
  | ToCountriesDirections
  | CitiesToCitiesDirections
  | CountriesToCountriesDirections
  | AllDirections;

export interface AirlineRef {
  iata_code: string;
  name: string;
}

export interface AirlinePromoSpecial extends BaseSpecial {
  type: 'AIRLINE_PROMO';
  airline: AirlineRef;
  purchase_period?: { from: string; to: string };
  travel_period?: { from: string; to: string };
  directions: Directions;
}

export type Special = EventSpecial | AirlinePromoSpecial;

export type SpecialOffer = HotOfferResult;
